import PasswordFormLayout from "./PasswordFormLayout";

export default PasswordFormLayout;
